export default __webpack_public_path__ + "48e7d5bc417863c8999c48b333283bde.png";